import { render } from "./popular_search.vue?vue&type=template&id=15d94b34&ts=true"
import script from "./popular_search.vue?vue&type=script&lang=ts"
export * from "./popular_search.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__